import { PropType, defineComponent } from "vue";
import { EnvCategory, EnvList, EnvironmentListResponse } from "@/interfaces/sdk-environment";

type CloseAction = () => void;
type CopyAction = (categoryId: number, environmentId: number, categoryName: string) => void;

export default defineComponent({
  name: "sdk-flow-copy-definition",
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    close: {
      type: Function as PropType<CloseAction>,
      required: true,
    },
    copy: {
      type: Function as PropType<CopyAction>,
      required: true,
    },
    environments: {
      type: Array as PropType<EnvironmentListResponse[]>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      selectedCategory: 0,
      currentCategory: {} as any,
    };
  },
  computed: {
    categories(): { label: string; value: number; envId: number }[] {
      if (this.environments.length) {
        const tempList: any[] = [{ label: "Selecione", value: 0, disabled: true }];
        this.environments.forEach((env: EnvironmentListResponse) => {
          env.enviroment.forEach((e: EnvList) => {
            e.categories.forEach((cat: EnvCategory) => {
              tempList.push({ label: `${env.company} - ${e.name} - ${cat.name}`, value: cat.id, envId: e.id });
            });
          });
        });
        return tempList.sort((a, b) => a.label.localeCompare(b.label));
      }
      return [];
    },
  },
  methods: {
    udpateCurrentCategory(value: number) {
      this.currentCategory = this.categories.find((cat) => cat.value === value);
    },
    copyDefinition() {
      this.copy(this.currentCategory.value, this.currentCategory.envId, this.currentCategory.label);
    },
    clearData() {
      this.selectedCategory = 0;
      this.currentCategory = {};
    },
  },
});
